import { useEffect, useState } from 'react'
import { FaTrashAlt } from 'react-icons/fa';
import PageTitle from '../../../components/PageTitle';
import api from "../../../services/api";
import TwoButtonsModal from '../../../shared/Bootstrap/TwoButtonsModal';
import Spinner from '../../../shared/Spinner/Spinner';
import Style from "./EnterprisePaymentOptionsStyle"

export interface PaymentOption {
    id: number,
    name: string,
    createdAt: string,
    updatedAt: string,
    installments: Installment[],
    paymentDates: PaymentDate[]
}

export interface Installment {
    id: number,
    interestRate: number,
    installment: number,
    maxDate: string,
    paymentOptionId: number
    paymentOptions: PaymentOption
}

export interface PaymentDate {
    date: number
}

export default function EnterprisePaymentOptions(props) {
    const [loading, setLoading] = useState(true);
    const [paymentOptions, setPaymentOptions] = useState<PaymentOption[]>([]);
    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [paymentToDelete, setPaymentToDelete] = useState<number>();

    useEffect(() => {
        setLoading(true);
        LoadPaymentOptions()
    }, [])

    async function LoadPaymentOptions() {
        try {
            const result: PaymentOption[] = await api.get(`/enterprises/${props.match.params.enterpriseId}/paymentOption`).then(result => result.data.paymentOptions)
            console.log(result);
            setPaymentOptions(result);
        }
        catch (error) {
            console.error("Erro pegando opções de pagamento: ", error)
        }
        finally {
            setLoading(false);
        }
    }

    function ConfirmPaymentDeletion(id: number) {
        setPaymentToDelete(id);
        setShowPopup(true);
    }

    async function DeletePaymentOption() {
        setLoading(true)
        const id = paymentToDelete;
        try {
            await api.delete(`/enterprises/${props.match.params.enterpriseId}/paymentOption`, {data: {id}})
        }
        catch (error) {
            console.error("Erro pegando opção de pagamento: ", error)
        }
        finally {
            setShowPopup(false);
            LoadPaymentOptions();
        }
    }

    const closePopup = () => setShowPopup(false);

    return(
        <Style>
            <PageTitle title="Opções de pagamento"/>
            <TwoButtonsModal
                show={showPopup}
                onHide={closePopup}
                loading={loading}
                title="Deletar opção de pagamento"
                body="Pode haver problemas caso exista pedidos com essa opção de pagamento. Você tem certeza que deseja deletar essa opção de pagamento?"
                secondaryText="Fechar"
                secondaryOnClick={closePopup}
                secondaryDisabled={loading}
                primaryText="Confirmar"
                primaryOnClick={DeletePaymentOption}
                primaryDisabled={loading}
            />
            <div>
                <button onClick={() => props.history.goBack()} className=" btn-secondary go-back">Voltar</button>
            </div>
            <Spinner spinning={loading} />
                <section className="table-title">
                    <h1>Opções de pagamento</h1>
                    <div>
                        <button onClick={() => props.history.push(`paymentOptions/create`)} className="btn-primary btn-create">Adicionar opção de pagamento</button>
                    </div>
                </section>
                <table className="table table-striped table-bordered table-hover main-table">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nome</th>
                            <th>Criado em</th>
                            <th>Modificado em</th>
                            <th>Apagar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paymentOptions.length > 0 && paymentOptions.map(paymentOption => {
                            return(
                                <tr className="clickable" key={paymentOption.id}>
                                    <td onClick={() => props.history.push(`paymentOptions/${paymentOption.id}`)}>{paymentOption.id}</td>
                                    <td onClick={() => props.history.push(`paymentOptions/${paymentOption.id}`)}>{paymentOption.name}</td>
                                    <td onClick={() => props.history.push(`paymentOptions/${paymentOption.id}`)}>{new Date(paymentOption.createdAt).toLocaleString()}</td>
                                    <td onClick={() => props.history.push(`paymentOptions/${paymentOption.id}`)}>{new Date(paymentOption.updatedAt).toLocaleString()}</td>
                                    <td className="action"><button className="delete" onClick={() => ConfirmPaymentDeletion(paymentOption.id)}>
                                        <FaTrashAlt className="icon" />
                                    </button></td>
                                </tr>
                            )   
                        })}
                    </tbody>
                </table>
        </Style>
    )
}